angular.module('app')
    .controller('EventSearch', function ($scope, $http, $timeout) {
        $scope.events = [];
        $scope.filteredEvents = [];
        $scope.shownEvents = [];
        $scope.sort = 'Date';
        $scope.dateOrder = "asc";
        $scope.selectedCmeHours = "";
        $scope.selectedTopic = "";
        $scope.selectedLocation = '';
        $scope.selectedYear = '';
        $scope.selectedEventType = '';
        $scope.cmeHours = ['All CME Hours', '0-10 Hours', '11-20 Hours', '21-40 Hours', '41-70 Hours', '70+ Hours'];
        $scope.user_date_range = "All Dates";
        $scope.ageRanges = ['All Dates', 'This Week', 'This Month', 'Next Month', 'This Quarter'];
        $scope.page = 1;
        $scope.pageSize = 1;
        $scope.pageStart = 0;
        $scope.pageEnd = 0;
        $scope.resultsPagesCount = 1;
        $scope.resultsCount = 0;
        $scope.loadingImage = $('.loading-overlay');
        $scope.searchMode = false;

        $scope.years = [];
        $scope.topics = [];
        $scope.eventTypes = [];

        $scope.init = function (pageSize) {
            if (pageSize) {
                $scope.pageSize = pageSize;
            }

            $scope.clear();
        }

       
        $scope.pagination = $('#pagination');
        var defaultOptions = {
            visiblePages: 3,
            next: 'Next',
            prev: 'Prev',
            onPageClick: function (event, page) {
                $timeout($scope.changePage(page), 1000);
            }
        }

        $scope.pagination.twbsPagination(
            $.extend({},
                defaultOptions, {
                    totalPages: $scope.resultsPagesCount

                }));

        $scope.changePage = function (page) {
            var skip = (page - 1) * $scope.pageSize;
            var pageEnd = skip + $scope.pageSize;

            if (pageEnd > $scope.resultsCount) {
                pageEnd = $scope.resultsCount;
            }

            $scope.shownEvents = $scope.filteredEvents.slice(skip, pageEnd);
            $scope.page = page;
            $scope.pageStart = skip + 1;
            $scope.pageEnd = pageEnd;
        }

        $scope.updatePagination = function () {
            if ($scope.resultsCount) {
                $scope.resultsPagesCount = Math.ceil($scope.resultsCount / $scope.pageSize);
            }

            if ($scope.resultsPagesCount < 2) {
                $scope.shownEvents = $scope.filteredEvents;
            }

            $scope.pagination.twbsPagination('destroy');

            $scope.pagination.twbsPagination(
                $.extend({},
                    defaultOptions, {
                        totalPages: $scope.resultsPagesCount
                    }));

            $scope.pageStart = 1;
            $scope.pageEnd = $scope.pageSize;
        }

        $scope.cmeHoursFilter = function (events) {
            if ($scope.selectedCmeHours === '0-10 Hours') {
                return events.filter(function (item) {
                    var hours = parseInt(item.CMEHours);
                    return (hours >= 0 && hours <= 10);
                });
            } else if ($scope.selectedCmeHours === '11-20 Hours') {
                return events.filter(function (item) {
                    var hours = parseInt(item.CMEHours);
                    return (hours >= 11 && hours <= 20);
                });
            } else if ($scope.selectedCmeHours === '21-40 Hours') {
                return events.filter(function (item) {
                    var hours = parseInt(item.CMEHours);
                    return (hours >= 21 && hours <= 40);
                });
            } else if ($scope.selectedCmeHours === '41-70 Hours') {
                return events.filter(function (item) {
                    var hours = parseInt(item.CMEHours);
                    return (hours >= 41 && hours <= 70);
                });
            } else if ($scope.selectedCmeHours === '70+ Hours') {
                return events.filter(function (item) {
                    var hours = parseInt(item.CMEHours);
                    return (hours > 70);
                });
            }

            return events;
        }


        $scope.eventTypeFilter = function (events) {

            var y = this.selectedEventType;
            if (y === "All Event Types") return events;
            return events.filter(function (item) {
                return (item.EventTypeText == y);
            });
        }

        $scope.topicFilter = function (events) {

            var y = this.selectedTopic;
            if (y === "All CME Topics") return events;
            return events.filter(function (item) {
                return (item.ListOfEventTags.indexOf(y) > -1);
            });
        }

        $scope.locationFilter = function (events) {

            var y = this.selectedLocation;
            if (y === "All Locations") return events;
            return events.filter(function (item) {
                //return (item.City.indexOf(y) > -1 || item.State.indexOf(y) > -1 || item.Country.indexOf(y) > -1 );
                return (item.Address.indexOf(y) > -1);
            });
        }


        $scope.yearFilter = function (events) {

            var y = this.selectedYear;
            if (y === "All Years") return events;
             return events.filter(function (item) {
                return (new Date(item.EventStartDate).getFullYear() === y);
            });
        }


        $scope.dateFilter = function (events) {
            var today = new Date();
            today = new Date(today.setHours(0, 0, 0, 0));
            var month = today.getMonth();
            var quarter = getQuarter(today);

            if ($scope.user_date_range === 'This Week') {
                var dayOfWeek = today.getDay();
                var restOfWeek = (7 - dayOfWeek) * 24 * 60 * 60 * 1000;
                return events.filter(function (item) {
                    return (new Date(item.EventStartDate).getTime() <= (today.getTime() + restOfWeek));
                });
            } else if ($scope.user_date_range === 'This Month') {
                return events.filter(function (item) {
                    return (new Date(item.EventStartDate).getMonth() === month);
                });
            } else if ($scope.user_date_range === 'Next Month') {
                return events.filter(function (item) {
                    return (new Date(item.EventStartDate).getMonth() === month + 1);
                });
            } else if ($scope.user_date_range === 'This Quarter') {
                return events.filter(function (item) {
                    return (getQuarter(new Date(item.EventStartDate)) === quarter);
                });
            }

            return events;
        }

        $scope.$watch('user_text_filter', function (nVal, oVal) {
            if (nVal !== oVal) { //&& nVal !== ''
                $scope.search();
            }
        });

        $scope.clear = function (e) {
            $scope.selectedCmeHours = "All CME Hours";
            $scope.selectedTopic = "All CME Topics";
            $scope.selectedYear = 'All Years';
            $scope.selectedEventType = 'All Event Types';
            $scope.selectedLocation = 'All Locations';
            $scope.user_text_filter = '';

            
        }

        $scope.reset = function (e)
        {
            $scope.clear();
            $scope.search();
            $scope.searchMode = false;            
            sessionStorage.removeItem('MasterCalendarFilters');
        }

        $scope.getIncludeFile = function (event) {
            // Make this more dynamic, but you get the idea
            switch (section) {
                case "Section A":
                    return 'partials/sectiona.html';
                case "Section B":
                    return 'partials/sectionb.html';
            }
        }

        $scope.search = function (e) {
            if (e) {
                e.preventDefault();
            }

            $scope.searchMode = true;

            $scope.loadingImage.show();

            var events = $scope.events;

            events = events.filter(function (item) {
                var regex = RegExp($scope.user_text_filter.toLowerCase());
                return regex.test(item.MeetingName.toLowerCase());
            });

           

            //events = $scope.cmeHoursFilter(events);
            //events = $scope.dateFilter(events);

            events = $scope.yearFilter(events);

            events = $scope.topicFilter(events);

            events = $scope.eventTypeFilter(events);

            events = $scope.locationFilter(events);

           

            $scope.filteredEvents = events;

            $scope.resultsCount = events.length;

            $scope.updatePagination();

            $scope.loadingImage.hide();

            $scope.saveToSessionStorage();
        }

        $scope.sortBy = function (sort) {

            if ($scope.dateOrder === "asc") {
                $scope.dateOrder = "desc";
            } else if ($scope.dateOrder === "desc") {
                $scope.dateOrder = "asc";
            }
            $scope.shownEvents = $scope.filteredEvents.reverse();
            $scope.changePage($scope.page);
        }

        $scope.showCalendar = function (sort) {
            $scope.reset();
            $scope.searchMode = false;
        }

        $scope.saveToSessionStorage = function () {
            var savedFilters = {
                'searchtext': $scope.user_text_filter,
                'selectedYear': $scope.selectedYear,
                'selectedEventType': $scope.selectedEventType,
                'selectedTopic': $scope.selectedTopic,
                'selectedLocation': $scope.selectedLocation
            };

            sessionStorage.setItem('MasterCalendarFilters', JSON.stringify(savedFilters));
        }

        $scope.RetrieveSavedFilters = function () {
            var v = sessionStorage.getItem('MasterCalendarFilters');
            if (v === null) return;
            var savedFilters = JSON.parse(v);
            $scope.user_text_filter = savedFilters.searchtext;

            $scope.selectedYear = savedFilters.selectedYear;
            $scope.selectedEventType = savedFilters.selectedEventType;
            $scope.selectedTopic = savedFilters.selectedTopic;
            $scope.selectedLocation = savedFilters.selectedLocation;

            $scope.search();
        }

        //get events
        $http.get('/api/events/currentevents').
            then(function (response) {

                $scope.events = response.data;
                $scope.filteredEvents = response.data;

               
               ///LOCATION START//
                var uniqueLocation = [];
                var uniqueLocation_US = [];
                var uniqueLocation_NonUS = [];

                var data_us = response.data.filter(function (item) {                   
                    return (item.Country === "US" || item.Country === "United States" || item.Country === "");
                });

                var data_nonus = response.data.filter(function (item) {
                    return (item.Country !== "US" && item.Country !== "United States" && item.Country !== "");
                });

                for (i = 0; i < data_us.length; i++) {                   
                    var locUS = data_us[i].State;                    
                    if (uniqueLocation_US.map(a=>a.text).indexOf(locUS) === -1 && locUS !== '') {
                        uniqueLocation_US.push({ text : locUS, group: 'United States' });
                    }
                }
                for (i = 0; i < data_nonus.length; i++) {
                    var locNonUS = data_nonus[i].Country;
                    if (uniqueLocation_NonUS.map(a => a.text).indexOf(locNonUS) === -1 && locNonUS !== '') {
                        uniqueLocation_NonUS.push({ text: locNonUS, group: 'International' });
                    }
                }

                uniqueLocation_US = uniqueLocation_US.sort((a, b) => (a.text > b.text) ? 1 : -1);
                uniqueLocation_NonUS = uniqueLocation_NonUS.sort((a, b) => (a.text > b.text) ? 1 : -1);
                uniqueLocation = uniqueLocation.concat(uniqueLocation_US);
                uniqueLocation = uniqueLocation.concat(uniqueLocation_NonUS);
                
                uniqueLocation.unshift({ text: 'All Locations', group: 'All Locations' });
               
                ///LOCATION END//


                var uniqueTopic = [];
                for (i = 0; i < response.data.length; i++) {
                    var tags = response.data[i].ListOfEventTags;
                    for (var j = 0; j < tags.length; j++) {

                        if (uniqueTopic.indexOf(tags[j]) === -1 && tags[j] !== '') {
                            uniqueTopic.push(tags[j]);
                        }

                    }
                    
                }

                uniqueTopic = uniqueTopic.sort();
                uniqueTopic.unshift('All CME Topics');

                var uniqueEventTypes = [];
                for (i = 0; i < response.data.length; i++) {
                    var eventType = response.data[i].EventTypeText;
                    if (uniqueEventTypes.indexOf(eventType) === -1 && eventType !== '') {
                        uniqueEventTypes.push(eventType);
                    }
                }

                uniqueEventTypes = uniqueEventTypes.sort();
                uniqueEventTypes.unshift('All Event Types');


                var eventDates = [];
                for (i = 0; i < response.data.length; i++) {
                    if (eventDates.indexOf(response.data[i].EventStartDate) === -1) {
                        eventDates.push(response.data[i].EventStartDate);
                    }
                }

                $scope.eventDates = eventDates;
                var _years = ["All Years"];
                for (var i = 0; i < eventDates.length; i++) {
                    var y = new Date(eventDates[i]).getFullYear();
                    if (_years.indexOf(y) === -1)
                    _years.push(y);
                } 

                $scope.years = _years;
                $scope.locations = uniqueLocation;
                $scope.topics = uniqueTopic;
                $scope.eventTypes = uniqueEventTypes;  
                $scope.resultsCount = response.data.length;

                $scope.updatePagination();

                //reload saved filters
                $scope.RetrieveSavedFilters();
            });

        function getQuarter(date) {
            var month = date.getMonth();

            if (month === 0 || month === 1 || month === 2) {
                return 1;
            } else if (month === 3 || month === 4 || month === 5) {
                return 2;
            } else if (month === 6 || month === 7 || month === 8) {
                return 3;
            } else if (month === 9 || month === 10 || month === 11) {
                return 4;
            }

            return -1;
        }
        
    });

$("button.events_sort_btn").click(function () {
    $("#events-sort-by").removeClass("is-invisible");
    $("#events-sort-by").toggleClass("expanded");
});




//////////////////
// WEBPACK FOOTER
// ./static/common/js/controllers/_eventSearchService.js
// module id = 7
// module chunks = 0